import { Skeleton, Typography } from "@mui/material";
import styles from "./FlagLayout.module.css";
import i18n from "../../../../../i18n";

type FlagProps = {
	color: string;
	backgroundColor: string;
	count?: number;
	label: string;
};

function CircleFlag({ color, backgroundColor, count, label }: FlagProps) {
	return (
		<div className={styles.circleWrapper}>
			<div className={styles.circle} style={{ backgroundColor }}>
				<Typography color={color}>{count ?? <Skeleton width={25} height={60} />}</Typography>
			</div>
			<Typography className={styles.circleLabel}>{label}</Typography>
		</div>
	);
}

function SquareFlag({ color, backgroundColor, count, label }: FlagProps) {
	return (
		<div className={styles.squareWrapper} style={{ backgroundColor }}>
			<Typography color={color} className={styles.flagCount}>
				{count ?? <Skeleton width={25} height={60} />}
			</Typography>
			<Typography className={styles.squareLabel}>{label}</Typography>
		</div>
	);
}

type FlagLayoutProps = {
	type: "circle" | "square";
	severeCount?: number;
	majorCount?: number;
	minorCount?: number;
	className?: string;
};

export default function FlagLayout({ type, severeCount, majorCount, minorCount, className }: FlagLayoutProps) {
	const renderFlag = (props: FlagProps) => {
		if (type === "circle") {
			return <CircleFlag {...props} />;
		} else {
			return <SquareFlag {...props} />;
		}
	};

	const totalCount =
		severeCount !== undefined && majorCount !== undefined && minorCount !== undefined
			? severeCount + majorCount + minorCount
			: undefined;

	return (
		<div className={`${styles[`${type}Layout`]} ${className || ""}`}>
			{renderFlag({
				color: "#D15127",
				backgroundColor: "#D1512726",
				count: severeCount,
				label: i18n.t("result.components.resultsPage.proctoringEventsTableTSX.severe"),
			})}
			{renderFlag({
				color: "#BF7A12",
				backgroundColor: "#FFF6EB",
				count: majorCount,
				label: i18n.t("result.components.resultsPage.proctoringEventsTableTSX.major"),
			})}
			{renderFlag({
				color: "#5E7831",
				backgroundColor: "#2E620E26",
				count: minorCount,
				label: i18n.t("result.components.resultsPage.proctoringEventsTableTSX.minor"),
			})}
			{renderFlag({
				color: "#657CCC",
				backgroundColor: "#657CCC26",
				count: totalCount,
				label: i18n.t("result.components.resultsPage.proctoringEventsTableTSX.flags"),
			})}
		</div>
	);
}
